import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ErrorComponent } from './core/error/error.component';
import { FastSelectionComponent } from './fast-selection/fast-selection.component';
import { FastDataComponent } from './fast-data/fast-data.component';
import { FastDataUpdateComponent } from './fast-data-update/fast-data-update.component';
import { AutoLoginPartialRoutesGuard } from 'angular-auth-oidc-client';
import { UnauthorizedComponent } from './core/unauthorized/unauthorized.component';
import { EntitlementGuard } from './entitlement.guard';

const routes: Routes = [
  { path: 'company/:companyId', component: FastSelectionComponent, canActivate: [AutoLoginPartialRoutesGuard, EntitlementGuard] },
  { path: 'error', component: ErrorComponent },
  { path: 'company/:companyId/details', component: FastDataComponent },
  { path: 'company/:companyId/edit', component: FastDataUpdateComponent },
  { path: 'unauthorized', component: UnauthorizedComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
